import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { getRoundFromIdAtom } from "../getRoundFromIdAtom/getRoundFromIdAtom";

export const getManualPaymentStatusOnGuestRoundAtom = atomFamily(
  (roundId: string) => {
    return atom((get) => {
      const round = get(getRoundFromIdAtom(roundId));
      if (round) {
        return round?.manualPaymentStatus;
      }
      return null;
    });
  }
);
